var map = {
	"./007-microphone-1.png": 618,
	"./010-home.png": 619,
	"./013-document-1.png": 620,
	"./014-document.png": 621,
	"./015-color-palette.png": 622,
	"./017-video-camera.png": 623,
	"./024-like.svg": 624,
	"./1.svg": 625,
	"./155-credit-card.svg": 626,
	"./2.svg": 627,
	"./3.svg": 628,
	"./4.svg": 629,
	"./New Customer.svg": 630,
	"./NotOpen.svg": 631,
	"./Opened.svg": 632,
	"./Profit.svg": 633,
	"./SalesRevenue.svg": 634,
	"./Sent.svg": 635,
	"./Slack.svg": 636,
	"./address.svg": 637,
	"./adobe.svg": 638,
	"./arrow-left.svg": 639,
	"./arrow-right.svg": 640,
	"./book.svg": 641,
	"./camera.svg": 642,
	"./chat.svg": 643,
	"./clipboard.svg": 644,
	"./cloud.svg": 645,
	"./columns.svg": 646,
	"./documentation.svg": 647,
	"./file.svg": 648,
	"./flat.svg": 649,
	"./headphone.svg": 650,
	"./iconfinder_trello_2317760.svg": 651,
	"./idea.svg": 652,
	"./image.png": 653,
	"./image.svg": 654,
	"./label.png": 655,
	"./layers.svg": 656,
	"./left.svg": 657,
	"./logo2.svg": 658,
	"./logo3.svg": 659,
	"./logo4.svg": 660,
	"./logo5.svg": 661,
	"./logo6.svg": 662,
	"./logoIn.svg": 663,
	"./paint.svg": 664,
	"./protection.svg": 665,
	"./quote.png": 666,
	"./repeat.svg": 667,
	"./right.svg": 668,
	"./strategy.svg": 669,
	"./theme.svg": 670,
	"./user.svg": 671,
	"./water-fall.svg": 672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;